import { hash } from "bcryptjs";
import { keycloakUtils } from "itsf-ui-common";

export const addUserEmailHashToGTM = async () => {
    try {
        const userProfile = await keycloakUtils.getUserProfile();
        const email = userProfile?.email ?? "";

        if (email && process.env.GTM_EMAIL_SALT) {
            hash(email, process.env.GTM_EMAIL_SALT, (err: Error, hashString: string) => {
                if (err) {
                    throw new Error("Couldn't load user's information.");
                }
                global.dataLayer.push({ userId: hashString });
            });
        }
    } catch (error) {
        throw new Error("Couldn't load user's information.");
    }
};
